import {
  AUDIT_DESCRIPTION_MAX_LENGTH,
  AUDIT_EXTRA_AUDITORS_MAX_LENGTH
} from '@cdab/scania/qpr/schema'
import { createZodParser, isISODate, parseDate } from '@cdab/utils'
import { z } from 'zod'

export const CreateAuditSchema = z.object({
  date: z
    .string()
    .refine(d => isISODate(d), 'Not a valid date')
    .transform(d => parseDate(d)),
  description: z.string().max(AUDIT_DESCRIPTION_MAX_LENGTH).optional(),
  extraAuditor: z.string().max(AUDIT_EXTRA_AUDITORS_MAX_LENGTH).optional(),
  auditTypeId: z.number()
})

export const auditFormParser = createZodParser(CreateAuditSchema)
